import * as actions from '../actions/actionTypes';

const initialState = {
  timeClocks: [],
  selectedStartDate: null,
  selectedEndDate: null,
};

const fetchTimeClocksSuccess = (state, action) => ({ ...state, timeClocks: action.timeClocks });

const deleteTimeClockSuccess = (state, action) => {
  const { timeClocks } = state;
  const { remake, data } = action;
  const date = data.newRegister || data.dtRegister;

  const newTimeClocks = timeClocks.map((timeClock) => {
    if (date.includes(timeClock.dtRef)) {
      let newObjs = [];
      if (remake) {
        if (data.category === 'INS') {
          newObjs = timeClock.objs.filter(obj => obj.id !== data.id);
        } else {
          newObjs = timeClock.objs.map((obj) => {
            if (obj.timeclockid === data.id) {
              return {
                ...obj,
                id: data.id,
                justification: null,
                category: null,
                timeclockid: null,
                remake: false,
              };
            }
            return obj;
          });
        }
      } else {
        newObjs = timeClock.objs.map((obj) => {
          if (obj.id === data.timeclockId) {
            return {
              ...obj,
              id: data.id,
              justification: data.justification,
              category: data.category,
              timeclockid: data.timeclockId,
              remake: true,
            };
          }
          return obj;
        });
      }
      return { ...timeClock, objs: newObjs };
    }
    return timeClock;
  });

  return { ...state, timeClocks: newTimeClocks };
};

const updateSelectedStartDateSuccess = (state, action) => ({ ...state, selectedStartDate: action.selectedStartDate });

const updateSelectedEndDateSuccess = (state, action) => ({ ...state, selectedEndDate: action.selectedEndDate });

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_TIMECLOCKS_SUCCESS:
      return fetchTimeClocksSuccess(state, action);
    case actions.DELETE_TIMECLOCK_SUCCESS:
      return deleteTimeClockSuccess(state, action);
    case actions.UPDATE_SELECTED_START_DATE_SUCCESS:
      return updateSelectedStartDateSuccess(state, action);
    case actions.UPDATE_SELECTED_END_DATE_SUCCESS:
      return updateSelectedEndDateSuccess(state, action);

    default:
      return state;
  }
};

export default reducer;
